// extracted by mini-css-extract-plugin
var _1 = "UploadImageStage-moduledisabled__vrCcP";
var _2 = "UploadImageStage-moduledragging__AG1F0";
var _3 = "UploadImageStage-moduleframe__R5JUC";
var _4 = "UploadImageStage-moduleframeActive__u6IkA";
var _5 = "UploadImageStage-modulegrid__bQqiN";
var _6 = "UploadImageStage-modulehandle__dF8Wp";
var _7 = "UploadImageStage-moduleimageHost__Pu2r3";
var _8 = "UploadImageStage-modulemask__GeDpX";
var _9 = "UploadImageStage-modulene__NeGA_";
var _a = "UploadImageStage-modulenw__wBSNA";
var _b = "UploadImageStage-modulese__bGjem";
var _c = "UploadImageStage-modulespinner__oiRiF";
var _d = "UploadImageStage-modulestage__PJhoD";
var _e = "UploadImageStage-modulesw__OOGY8";
export { _1 as "disabled", _2 as "dragging", _3 as "frame", _4 as "frameActive", _5 as "grid", _6 as "handle", _7 as "imageHost", _8 as "mask", _9 as "ne", _a as "nw", _b as "se", _c as "spinner", _d as "stage", _e as "sw" }
